import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { VehicleGroup } from '../schemas/vehicle-group.schema';

/**
 * Edits a Vehicle Group
 * @param vehicleGroup The Vehicle Group being edited
 * @returns Data object indicating success
 */
export function putVehicleGroups(
  this: unknown,
  vehicleGroup: Partial<VehicleGroup>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).vehicleGroupsUrl}/${String(
          vehicleGroup.vehicleGroupId
        )}`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify(vehicleGroup),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: z.boolean(),
        message: z.string(),
      })
    )
  );
}
